import { render, staticRenderFns } from "./line2.vue?vue&type=template&id=51cd9a59&scoped=true&"
import script from "./line2.vue?vue&type=script&lang=js&"
export * from "./line2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cd9a59",
  null
  
)

export default component.exports